import { createContext, useContext } from "react";

const PublicSpaceContext = createContext({
  basePath: "",
  slug: "",
  customDomain: false,
});

export function PublicSpaceProvider({ value, children }) {
  return <PublicSpaceContext.Provider value={value}>{children}</PublicSpaceContext.Provider>;
}

export function usePublicSpace() {
  return useContext(PublicSpaceContext);
}
